
import React, { useState  , useReducer , useCallback , useEffect  }  from 'react';
import { useTranslation } from 'react-i18next';
import Button from "@material-ui/core/Button";
import { PageHeading } from "../../../../../SharedComponents";
import { Spinner } from '../../../../../Components' ; 
import { showSuccess  , showError , bottomBoxComponentUpdate} from '../../../../../Helper' ; 
import { GetAllPropertyRatingLifeStyleAPI  ,  UpdatePropertyRatingLifeStyleAPI } from '../../../../../Services' ; 
import { LifeStyleContent } from './LifeStyleContent' ; 
import { Luxury } from './Luxury'; 

  export const LifeStyleView = ({parentTranslationPath , translationPath  , ratingPercentage} ) => { 
    const { t } = useTranslation(parentTranslationPath);
    const[isLoading ,setIsLoading] = useState(false);
    const [lifeStyleScoresRatingPercentage ,setLifeStyleScoresRatingPercentage]  = useState(0) ;

    const reducer = (state, action) => {
        if (action.id !== 'edit') return { ...state, [action.id]: action.value };
        if (action.id === 'edit') {
          return {
            ...action.value,
          };
        }
        return undefined;
      };

      const [state, setState] = useReducer(reducer, {
        updatePropertyRatingLifeStyleDtos :[] ,
        propertyRatingLuxuryDto : null , 

      });

    const GetAllPropertyRatingLifeStyle = useCallback(async () => 
    {
        setIsLoading(true);
        const res = await GetAllPropertyRatingLifeStyleAPI();
        if (!((res && res.data && res.data.ErrorId) || !res)) 
           setState({ id: 'edit', value:(res) });
        else setState({ id: 'edit', value: null});
         setIsLoading(false);
    });


    const reloadData = () => 
    {
      GetAllPropertyRatingLifeStyle(); 
    };

    const saveHandler = async () => {
      setIsLoading(true);

      const res = await UpdatePropertyRatingLifeStyleAPI(state); 
      if (!((res && res.status && res.status !== 200) || !res)) {
        showSuccess(t(`${translationPath}life-style-scores-updated-successfully`));
          reloadData();
      }
      else  showError(t(`${translationPath}life-style-scores-updated-failed`));
       
      setIsLoading(false) ;
  };

    useEffect(() => {
      reloadData();
      if(ratingPercentage)
        {
          const rating = ratingPercentage.find((f) => f.propertyRatingTabName === "Life style");
          setLifeStyleScoresRatingPercentage((rating && rating.score) || 0 ) ; 
        }
    }, [ratingPercentage]);

    useEffect( () => {
      bottomBoxComponentUpdate(null);
    },
    []
  );

    return (
      <div className="w-100 mt-4">
        <Spinner isActive={isLoading} isAbsolute />
        <div className="d-flex-v-center-h-between">
          <PageHeading
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            headerTitle={"life-style"}
            wrapperClasses={"px-4 pt-2 w-75"}
            headerTitleClasses={"fz-30"}
            subTitleClasses={"fz-12 m-0"}
            subTitle={''}
            titleWithPercentage={`${lifeStyleScoresRatingPercentage}%`}
          />
          
          <div className="w-25 px-4 d-flex-center fj-end">
          <Button
              className="btns theme-propx outlined"
              id="btn-cancel"
              onClick={() => {
               reloadData()
              }}
            >
              {t(`${translationPath}cancel`)}
            </Button>
            <Button
              className="btns theme-propx solid"
              id="btn-save"
              onClick={() => saveHandler()}
            >
              {t(`${translationPath}save-changes`)}
            </Button>
           
          </div>
         </div>
        <div className="property-rating-container">
          <div className='life-style-criteria'>
            <div className='life-style-section b-bottom'>
            <LifeStyleContent
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                state={state}  
                setState={setState}
              /> 
              </div>
              <div className='life-style-section b-bottom'>
              <Luxury
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                state={state}  
                setState={setState}
              /> 
              </div> 
          </div>   
        </div>
      </div>
    );
  } ; 
